export const DefaultViewLevelTypes = {
  User: 'user',
  Account: 'account',
}
